import React, { useEffect } from "react";
import HorseCard from ".";
import Button from "components/Buttons";
import Loader from "components/Spinners/Loader";
import PlusIcon from "assets/icons/plus.svg?react";
import { Modal, useModalStore } from "stores/modal/useModalStore";
import { useHorseStore } from "stores/horse/useHorseStore";

export const HorseCards = () => {
  const open = useModalStore((s) => s.open);

  const horses = useHorseStore(state => state.horses);
  const loading = useHorseStore(state => state.loading);
  const nextToken = useHorseStore(state => state.nextToken);
  const isHorsesLoading = useHorseStore(state => state.isHorsesLoading);

  const setDeleteHorses = useHorseStore(action => action.setDeleteHorses);
  const fetchHorseData = useHorseStore(action => action.fetchHorseData);
  const loadMoreHorses = useHorseStore(action => action.loadMoreHorses);

  const onHandleAddClick = () => open(Modal.AddHorse);
  const onHandleEditClick = () => open(Modal.EditHorse);
  const onHandleDelete = () => open(Modal.DeleteHorse);

  useEffect(() => {
    fetchHorseData();
  }, [fetchHorseData]);

  const selectAllHorsesIds = (isEmpty = false) => {
    if (!isEmpty) {
      const allHorsesIds = horses?.map(
        (item) => item?.id
      );
      setDeleteHorses(allHorsesIds);
    } else {
      setDeleteHorses([]);
    }
  };

  return (
    <>
      <div className="flex gap-5 flex-wrap mx-auto w-[90%] md:w-full justify-start">
        <div className="clay-card-dashboard !h-[332px]">
          <div className="prof_card_head">
            <h1 className="clay-card-text-dashboard">Add Horse</h1>
            <Button
              onClick={onHandleAddClick}
              transparent
              className="decor_plus_icon_dashboard"
            >
              <PlusIcon />
            </Button>
          </div>
          <div className="prof-schedule-dashboard">
            <div className="w-full flex gap-[41px]">
              <div>
                <h4>-</h4>
                <p>Date of Birth</p>
              </div>
              <div>
                <h4>-</h4>
                <p>Last scan</p>
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center items-center w-[400px]">
            <Loader
              filledColor="#2b364b"
              className="!h-[50px] !flex !items-center !text-center !justify-center"
            />
          </div>
        ) : (
          horses?.map((item, i) => (
            <div className="w-full lg:w-[400px]" key={i}>
              <HorseCard
                data={item}
                onHandleDelete={onHandleDelete}
                onHandleEditClick={onHandleEditClick}
                selectAllHorsesIds={selectAllHorsesIds}
              />
            </div>
          ))
        )}
      </div>
      {loading || nextToken && (
        <div className="flex justify-center mx-auto">
          <Button
            className="load_more_btn mt-[20px]"
            primary
            whiteOutline
            loading={isHorsesLoading}
            onClick={loadMoreHorses}
          >
            load more
          </Button>
        </div>
      )}
    </>
  );
};
